// removed by extract-text-webpack-plugin
module.exports = {"Logo":"-name__-loca-__19WaN"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Logo/Logo.css
// module id = 157
// module chunks = 0